import { AnchorHTMLAttributes, HTMLAttributes, OlHTMLAttributes } from 'react'
import Markdown from 'react-markdown'

const AElement = ({
  children,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a
    {...props}
    target="_blank"
    rel="noopener noreferrer"
    className="text-bluePrimary-800 underline"
  >
    {children}
  </a>
)

const OlElement = ({ children }: OlHTMLAttributes<HTMLOListElement>) => (
  <ol className="list-decimal pl-5">{children}</ol>
)

const UlElement = ({ children }: HTMLAttributes<HTMLUListElement>) => (
  <ul className="list-disc pl-5">{children}</ul>
)

export const UniversalMarkdown = ({ children }: { children: string }) => (
  <div className="flex flex-col gap-2">
    <Markdown
      components={{
        a: AElement,
        ol: OlElement,
        ul: UlElement
      }}
    >
      {children}
    </Markdown>
  </div>
)
